<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Voucher } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { Button } from '@/components/ui/button';
    import DownloadVouchers from './DownloadVouchers.vue';
    import DownloadStatements from './DownloadStatements.vue';

    interface Props {
        voucher: Voucher;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="voucher">
        <div v-if="hasPermission(Permission.VOUCHERS_VIEW)">
            <DownloadVouchers
                v-if="voucher.has_voucher"
                :voucher="voucher"
            />

            <DownloadStatements
                v-else-if="voucher.has_statement"
                :statement="voucher.statement"
            />
            <Button
                v-else-if="voucher.is_valid_no_file"
                variant="delete"
                size="xs"
                :disabled="true"
            >
                {{ $t('button-text.uploaded-without-voucher') }}
            </Button>
        </div>
    </DataTableActions>
</template>
